var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.groupedPrices.length > 0
    ? _c("div", { staticClass: "row is-darken" }, [
        _c("div", { staticClass: "cell cell--name" }, [
          _c("strong", [_vm._v("- davon " + _vm._s(_vm.sortGroup.value))]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cell is-price-cell is-small cell--currency" },
          [
            _c("span", { staticClass: "is-currency" }, [
              _vm._v(_vm._s(_vm.orderCurrency)),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cell is-price-cell cell--sell" },
          [
            _c("input-price", {
              attrs: { readOnly: "", value: _vm.summary.group },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cell is-price-cell cell--profit" },
          [
            _c("input-price", {
              attrs: { readOnly: "", value: _vm.summary.person },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cell is-price-cell is-margin-cell cell--margin" },
          [
            _c("input-price", {
              attrs: { readOnly: "", value: _vm.summary.single },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "cell is-actions is-small-cell cell--actions",
        }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }